module.exports = __webpack_public_path__ + "static/Shopify-logo@2x.f60220be.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Shopify-logo@2x.png
// module id = ./src/images/Shopify-logo@2x.png
// module chunks = 4016850265702045000